import { render, staticRenderFns } from "./editTravelAmountModel.vue?vue&type=template&id=6b227b91&scoped=true&"
import script from "./editTravelAmountModel.vue?vue&type=script&lang=js&"
export * from "./editTravelAmountModel.vue?vue&type=script&lang=js&"
import style0 from "./editTravelAmountModel.vue?vue&type=style&index=0&id=6b227b91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b227b91",
  null
  
)

export default component.exports